import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class VerificationService {
    private api: string = `${environment.apiUrl}/verifications`;

    constructor(
        private readonly http: HttpClient,
    ) {
    }

    sendVerificationEmail(membershipId: number): Observable<void> {
        return this.http.post<void>(`${this.api}/send/${membershipId}/`, {});
    }

    verifyEmail(token: string): Observable<void> {
        return this.http.get<void>(`${this.api}/verify/${token}/`);
    }
}
